import React from 'react'

import Image from 'shared/components/common/Image'
import Link from 'shared/components/common/link'
import { t } from 'src/translations'

export const PoweredByToast = () => {
  return (
    <div className='poweredBy' data-testid='powered-by-toast'>
      <Link
        href='https://toast.app'
        blockAttribution
        ariaLabel={t('footer.powered-by-toast')}
      >
        <Image
          aria-hidden='true'
          alt={t('footer.toast-logo')}
          src='icons/toast-logo-filled.svg'
        />
        <Image
          src='icons/powered-by-toast-text.svg'
          alt={t('footer.powered-by-toast')}
          className='poweredByToastText'
        />
      </Link>
    </div>
  )
}
